// Library genelinde paylaşılan menü stilleri (light + dark)
export const libraryMenuContentClass =
  "z-[1200] min-w-[200px] rounded-xl border border-border-secondary dark:border-gray-700 bg-bg-primary dark:bg-gray-900 p-1 shadow-xl text-text-primary dark:text-gray-100";

export const libraryMenuItemClass =
  "flex items-center gap-2.5 rounded-lg px-2.5 py-2 text-sm cursor-pointer text-text-secondary dark:text-gray-200 focus:bg-bg-secondary dark:focus:bg-gray-800 focus:text-text-primary dark:focus:text-white data-[highlighted]:bg-bg-secondary dark:data-[highlighted]:bg-gray-800";

export const libraryMenuDangerItemClass =
  "text-red-600 dark:text-red-400 focus:text-red-600 dark:focus:text-red-400 focus:bg-red-50 dark:focus:bg-red-500/10 data-[highlighted]:bg-red-50 dark:data-[highlighted]:bg-red-500/10";

/**
 * Hover'da butonun altından vuran ışık: radyal parıltı (before) ve alt kenarda ince
 * bir ışık çizgisi (after). Light temada koyu, dark temada beyaz ışık.
 */
export const libraryGlowButtonClass = [
  "relative isolate overflow-hidden",
  "before:pointer-events-none before:absolute before:inset-0 before:-z-10 before:translate-y-2 before:opacity-0 before:transition-[opacity,transform] before:duration-300",
  "before:bg-[radial-gradient(ellipse_75%_70%_at_50%_100%,rgba(0,0,0,0.16),transparent)]",
  "dark:before:bg-[radial-gradient(ellipse_75%_70%_at_50%_100%,rgba(255,255,255,0.32),transparent)]",
  "after:pointer-events-none after:absolute after:inset-x-2 after:bottom-0 after:h-px after:opacity-0 after:transition-opacity after:duration-300",
  "after:bg-gradient-to-r after:from-transparent after:via-black/35 after:to-transparent dark:after:via-white/80",
  "hover:before:translate-y-0 hover:before:opacity-100 hover:after:opacity-100",
  "focus-visible:before:translate-y-0 focus-visible:before:opacity-100 focus-visible:after:opacity-100",
  "data-[state=open]:before:translate-y-0 data-[state=open]:before:opacity-100 data-[state=open]:after:opacity-100",
].join(" ");

export const libraryMenuSeparatorClass =
  "-mx-1 my-1 h-px bg-border-secondary dark:bg-gray-800";
